/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'recently': {
    width: 200,
    height: 200,
    viewBox: '0 0 200 200',
    data: '<path pid="0" fill-rule="evenodd" d="M9.37 15.63C4.2 15.63 0 19.82 0 25v37.5c0 5.18 4.2 9.38 9.37 9.38H50c5.18 0 9.37-4.2 9.37-9.38 0-5.18-4.19-9.37-9.37-9.37H33.69C48.4 32.34 72.6 18.75 100 18.75c44.87 0 81.25 36.38 81.25 81.25s-36.38 81.25-81.25 81.25c-37.82 0-69.51-25.88-78.57-60.87l-.16.05c-1.27-3.68-4.66-6.37-8.77-6.37a9.38 9.38 0 00-9.38 9.38c0 .92.28 1.76.53 2.6l-.1.03c.06.23.18.43.24.66.07.18.11.36.19.54C15.88 169.2 54.26 200 100 200c55.23 0 100-44.77 100-100S155.23 0 100 0C66.48 0 36.88 16.52 18.75 41.84V25c0-5.18-4.2-9.37-9.38-9.37zm140.625 92.187c0-5.18-4.19-9.38-9.37-9.38h-31.25v-46.88c0-5.17-4.2-9.37-9.38-9.37-5.17 0-9.37 4.2-9.37 9.37v56.25c0 5.18 4.2 9.38 9.37 9.38h40.63c5.18 0 9.37-4.2 9.37-9.37z" _fill="#333"/>'
  }
})
